import React from 'react';
import { IMaskInput } from 'react-imask';
import type { CSSProp } from 'styled-components';

import { Field } from 'common/components/form/Input';
import { getNumber } from 'common/components/form/Number/helpers';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldWrapper, IFormInput } from 'common/components/form/Wrapper';

import { InputLeftSide, InputRightSide, InputWrapperLabel } from '../Wrapper/Wrapper.styled';

export interface INumberField extends Omit<IFormInput, 'type' | 'icon'> {
  scale?: number;
  leftSideSymbol?: React.ReactNode;
  extendedStyles?: CSSProp;
}

export const NumberField = ({
  name,
  label,
  disabled,
  scale = 0,
  leftSideSymbol,
  extendedStyles,
  ...rest
}: INumberField) => {
  const { error, hasError, setValue } = useFormikField(name);

  return (
    <FieldWrapper
      name={name}
      label={label}
      isRequired={rest.required}
      isDisabled={disabled}
      error={hasError ? `${error}` : undefined}
    >
      <InputWrapperLabel
        $hasError={hasError}
        $isDisabled={disabled}
        $extendedStyles={extendedStyles}
      >
        {leftSideSymbol ? <InputLeftSide>{leftSideSymbol}</InputLeftSide> : null}

        <Field type="text" name={name} disabled={disabled}>
          {({ field }: any) => (
            <>
              <IMaskInput
                {...rest}
                mask={Number}
                scale={scale}
                thousandsSeparator=" "
                radix=","
                mapToRadix={['.', ',']}
                value={
                  typeof field.value === 'number'
                    ? String(field.value).replace('.', ',')
                    : field.value ?? ''
                }
                onAccept={value => {
                  setValue(value);
                }}
                onBlur={() => {
                  if (field.value === '' || field.value === '-') {
                    setValue(undefined);
                  } else if (typeof field.value === 'string') {
                    const normalized = field.value.replace(',', '.');
                    const num = Number(normalized);

                    if (!Number.isNaN(num)) {
                      setValue(num);
                    }
                  }
                }}
                padFractionalZeros={false}
              />

              <InputRightSide>{rest.rightSideSymbol}</InputRightSide>
            </>
          )}
        </Field>
      </InputWrapperLabel>
    </FieldWrapper>
  );
};
